import { type FC, useState } from 'react'
import { Button } from '../../../../components/Button/Button'
import { ConfirmDialog } from '../../../Scheduling/shared/ConfirmDialog'
import { SettingsCard, SettingsRow } from '../../../Setup/Scheduling/sections/SettingsSection'

interface SectionProps {
  title?: string
  subtitle?: string
  confirmBody?: string
  disabled?: boolean
  onReset: () => void
}

export const ResetToAccountDefaults: FC<SectionProps> = ({
  title = 'Reset to account defaults',
  subtitle = "Replace your scheduling settings with the account defaults. You'll lose any changes you've made here.",
  confirmBody = "This replaces your scheduling settings with the account defaults. Any changes you've made here will be lost.",
  disabled = false,
  onReset,
}) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const handleConfirm = () => {
    onReset()
    setIsConfirmOpen(false)
  }

  return (
    <SettingsCard>
      <SettingsRow className='d-flex flex-wrap align-items-center justify-content-between gap-3'>
        <div className='d-flex flex-column'>
          <span className='bold'>{title}</span>
          <span className='paragraph-small zocks-text-gray-600'>{subtitle}</span>
        </div>
        <Button variant='grayButton' className='text-nowrap' disabled={disabled} onClick={() => setIsConfirmOpen(true)}>
          Reset
        </Button>
      </SettingsRow>
      {isConfirmOpen ? (
        <ConfirmDialog
          title='Reset to account defaults?'
          body={confirmBody}
          confirmLabel='Reset settings'
          onConfirm={handleConfirm}
          onCancel={() => setIsConfirmOpen(false)}
        />
      ) : null}
    </SettingsCard>
  )
}
